import newsIndex from '../../pages/news'

const NewsRoute = [
  {
    path: '/news',
    name: 'news',
    component: newsIndex
  }
]
export default NewsRoute



// WEBPACK FOOTER //
// ./src/router/news/index.js